import React from 'react';
import { Box, useTheme } from '@mui/material';

const TONE_BY_STATUS = {
  // Active / paid / available family
  active: 'active', paid: 'active', available: 'active', completed: 'active', ready: 'active', verified: 'active', success: 'active',
  // Trial / pending / reserved family
  trial: 'trial', trialing: 'trial', reserved: 'trial', pending: 'trial', warning: 'trial',
  // Danger / suspended / occupied / past-due / expired family
  suspended: 'danger', past_due: 'danger', occupied: 'danger', failed: 'danger', cancelled: 'danger', refunded: 'danger', error: 'danger', expired: 'danger', incomplete_expired: 'danger', unpaid: 'danger',
  // Canceled / unavailable / ended family
  canceled: 'neutral', unavailable: 'neutral', ended: 'neutral', inactive: 'neutral', closed: 'neutral', archived: 'neutral',
  // Info / new family
  new: 'info', info: 'info', dine_in: 'info',
  // Preparing / in-progress family
  preparing: 'progress', in_progress: 'progress', processing: 'progress',
};

/**
 * Status badge with semantic color mapping. Pass `status` and we look up the
 * tone from theme.palette.mesoon.status; pass `tone` directly to override.
 */
const StatusPill = ({ status, label, tone, size = 'sm', dot = false, sx }) => {
  const theme = useTheme();
  const statusKey = String(status || '').toLowerCase().replace(/[-\s]/g, '_');
  const resolvedTone = tone || TONE_BY_STATUS[statusKey] || 'neutral';
  const palette = theme.palette.mesoon?.status?.[resolvedTone] || theme.palette.mesoon?.status?.neutral || { bg: '#F3F4F6', text: '#4B5563' };

  const text = label != null ? label : String(status || '').replace(/_/g, ' ');
  const padding = size === 'sm' ? '4px 10px' : '6px 14px';
  const fontSize = size === 'sm' ? 12 : 13;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        padding,
        borderRadius: 9999,
        backgroundColor: palette.bg,
        color: palette.text,
        fontSize,
        fontWeight: 600,
        lineHeight: 1.4,
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {dot && (
        <Box
          component="span"
          aria-hidden="true"
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: palette.text,
            opacity: 0.85,
          }}
        />
      )}
      {text}
    </Box>
  );
};

export default StatusPill;
